<template>
  <header class="site-header" :class="{ 'site-header--dark': dark }">
    <a href="/" class="site-brand" aria-label="Exatom Score, home">
      <exatom-logo :inverse="dark" :width="104" />
      <span class="site-brand-pill">Score</span>
    </a>
    <nav class="site-nav" aria-label="Main">
      <a :href="`${anchorBase}#how-it-works`">How it works</a>
      <a :href="`${anchorBase}#what-we-check`">What we check</a>
      <a :href="`${anchorBase}#chrome-extension`">Chrome extension</a>
      <a :href="pricingUrl" target="_blank" rel="noopener">Pricing</a>
    </nav>
    <div class="site-header-actions">
      <a :href="loginUrl" class="site-login">Log in</a>
      <a :href="signupUrl" class="ex-btn ex-btn--small" :class="dark ? 'ex-btn--light' : 'ex-btn--primary'">
        <span class="ex-btn__label" data-label="Start free plan">Start free plan</span>
      </a>
    </div>
  </header>
</template>

<script>
import ExatomLogo from './ExatomLogo.vue'
import { LOGIN_URL, PRICING_URL, SIGNUP_URL } from '../score/links'

export default {
  name: 'SiteHeader',
  components: { ExatomLogo },
  props: {
    // Dark on the home page hero, light with a hairline on the result pages.
    dark: { type: Boolean, default: false },
    // The home page links to its own sections; other pages link back to them.
    onHome: { type: Boolean, default: false }
  },
  data () {
    return { loginUrl: LOGIN_URL, pricingUrl: PRICING_URL, signupUrl: SIGNUP_URL }
  },
  computed: {
    anchorBase () {
      return this.onHome ? '' : '/'
    }
  }
}
</script>

<style scoped>
.site-header {
  display: flex;
  align-items: center;
  gap: 40px;
  height: 80px;
  padding: 0 var(--ex-page-gutter);
  background: var(--ex-color-white);
  border-bottom: 1px solid var(--ex-color-hairline);
}

.site-header--dark {
  background: var(--ex-color-dark);
  border-bottom-color: transparent;
}

.site-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.site-brand-pill {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 9px;
  border-radius: var(--ex-radius-pill);
  background: var(--ex-color-blue-light);
  color: var(--ex-color-blue);
  font-size: 12px;
  font-weight: 600;
}

.site-header--dark .site-brand-pill {
  background: var(--ex-color-on-dark-subtle);
  color: var(--ex-color-white);
}

.site-nav {
  display: flex;
  gap: 28px;
  margin-left: 16px;
}

.site-nav a {
  color: var(--ex-color-neutral-700);
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
}

.site-header--dark .site-nav a {
  color: var(--ex-color-neutral-100);
}

.site-nav a:hover {
  text-decoration: underline;
}

.site-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}

.site-login {
  margin-right: 8px;
  color: var(--ex-color-dark);
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
}

.site-header--dark .site-login {
  color: var(--ex-color-white);
}

.site-login:hover {
  color: inherit;
  text-decoration: underline;
}

@media (max-width: 960px) {
  .site-header {
    padding: 0 16px;
    gap: 16px;
  }

  .site-nav,
  .site-login {
    display: none;
  }
}

@media print {
  .site-header {
    display: none;
  }
}
</style>
